import { BiX } from "react-icons/bi"
import './containerform.css'
export default function ContainerForm({children,cadastramento,finalizar}){
    return(
         <div className='envelope_box'>
            <div className='cad_box'>
                <div className='cabecalhoForm'>
                    <BiX size={30} onClick={cadastramento}/>
                    <p className='cabecalhoFormp'
                    >Preencha o formulário</p>
                </div>
                <form className='formBody' onSubmit={finalizar}>
                    {children}
                </form>
            </div>
        </div>
    )
}